import formatISO from "date-fns/formatISO";

import { InsuranceApi } from "../../../../Api/InsuranceApi";
import { Filters } from "../../../Utils/Filters/types";

import { InsuranceFormState } from "./insuranceForm";
import { GetInsuranceDoctorsFilterDto } from "@apiModels/Insurance/GetInsuranceDoctorsFilterDto.csharp";

export interface InsuranceFormRequest
  extends Omit<
    GetInsuranceDoctorsFilterDto,
    "specializationId" | "keywords" | "filterFavourite"
  > {
  doctorId?: string;
}

const api = new InsuranceApi();

export async function insuranceFormSubmit(data: InsuranceFormState) {
  const formData = new FormData();

  for (const [name, value] of Object.entries(data)) {
    switch (name) {
      case "submitted":
        break;
      case "filters":
        const ids = mapFiltersToFormIds(value);
        const { serviceId, centerIds, doctorId, locationIds } = ids;

        if (serviceId) {
          formData.append("serviceId", serviceId);
        }

        if (doctorId) {
          formData.append("doctorId", doctorId);
        }

        if (centerIds) {
          centerIds.map((centerId) => formData.append("centerIds", centerId));
        }

        if (locationIds) {
          locationIds.map((locationId) =>
            formData.append("locationIds", locationId)
          );
        }
        break;

      case "referenceFiles":
        if (value) {
          value.map((file: File) => formData.append(name, file));
        }
        break;
      case "date":
        formData.append(
          name,
          formatISO(value!, { representation: "complete" })
        );
        break;
      default:
        formData.append(name, value);
    }
  }

  return await api.requestBooking(formData);
}

const mapFiltersToFormIds = (filters: Filters) => {
  const ids: InsuranceFormRequest = {};
  const { service, locations, doctor } = filters;

  if (service) {
    ids.serviceId = service.id;
  }

  if (doctor) {
    ids.doctorId = doctor.id;
  }

  if (locations) {
    locations.map((location) => {
      if (location.isLocation) {
        ids.centerIds = [...(ids.centerIds ?? []), ...location.centers];
        return;
      }
      ids.centerIds = [...(ids.centerIds ?? []), location.id];
    });

    ids.centerIds = Array.from(new Set(ids.centerIds));
  }

  return ids;
};
